/**
 * **장비 상세 카드 비전 칸(`VisionPane`)의 규칙** — 화면(DOM)을 모른다.
 *
 * ⚠ 2026-09-28 ~ 10-02 에는 모니터링 오른쪽 열에 세 모듈 영상이 세로로 섰다(eric 「총 세개의 영상 … 오른쪽 고정으로」).
 *   2026-10-02 eric 「장비의 상세.. 내용 위에 넣어줘 … 오른쪽에. .비전.. 은 없애..」로 고른 장비의 칸 하나가 됐다.
 *
 * 🔴 **떠 있는 창(`VisionFloat` · 2026-09-26 ~ 09-28)은 걷혔다.** 끌기 · 크기 조절 · 접기 · 자리 저장을
 *    되살리지 마라. 그때 쓰던 저장 키는 읽지 않고 지운다(`VISION_FLOAT_LEGACY_KEYS`).
 */

/** 카메라가 달린 장비 — 원심분리기 · 어셈블러 · 염색기(6축 로봇은 비전 칸이 없다 · `figureTabs` 의 `vision` 탭과 같은 셋) */
export const VISION_DEVICES = ['cent', 'asm', 'stain'] as const

export type VisionDevice = (typeof VISION_DEVICES)[number]

/** 그 장비에 비전 칸이 서는가 — 타입을 좁힌다 */
export function isVisionDevice(key: string): key is VisionDevice {
  return (VISION_DEVICES as readonly string[]).includes(key)
}

/**
 * 카메라 **기본** 비율 — `.fig-vstream` 의 `aspect-ratio: 16 / 9` 와 같은 값이다.
 * 🔴 영상이 붙으면 그 영상의 실제 비율(`videoWidth / videoHeight`)이 이긴다. 이 값은 «아직 영상이 없을 때»
 *    한 곳이다 — 다른 곳에 16/9 를 또 적지 마라. 칸의 영상 비율(`--viscol-aspect`)이 이 값 또는 실측 비율을 쓴다.
 */
export const VISION_ASPECT = 16 / 9

/**
 * 떠 있는 창이 쓰던 저장 키 — **읽지 않고 지운다.** 창이 걷혀 남은 값은 쓰레기다.
 * ⚠ 이 목록을 «읽는» 코드를 만들지 마라(시험이 막는다).
 */
export const VISION_FLOAT_LEGACY_KEYS: readonly string[] = [
  'ctcells:visionFloat',
  'ctcells:visionFloat.v2',
]

/** 영상 원소에서 읽은 비율이 쓸 만한가 — 메타데이터 전(0 · NaN)이나 터무니없는 값은 버린다 */
export function usableAspect(width: number, height: number): number | undefined {
  if (!(width > 0) || !(height > 0)) return undefined
  const aspect = width / height
  return Number.isFinite(aspect) && aspect > 0.2 && aspect < 5 ? aspect : undefined
}
